module.exports = __webpack_public_path__ + "img/1.4aa5fda4.png";